import React from 'react'
import styles from './GoogleSignInButton.module.css'
import GoogleIcon from '../../assets/google/logo-google.webp'

type Props = {
  onSuccess: (response: any) => void
  onError?: (error: any) => void
  label?: string
  token?: string
  mode?: 'login' | 'registration'
}

export function GoogleSignInButton({
  onSuccess,
  onError,
  label = '',
  token,
  mode = 'registration',
}: Props) {
  const handleClick = () => {
    const clientId = '60431650499-lvp0a9ip0g5o1f4a5b2fcc5lckrjjr6e.apps.googleusercontent.com'
    const redirectUri = encodeURIComponent(window.location.origin + '/auth/google/callback')
    const scope = encodeURIComponent('openid profile email')

    const state = mode === 'registration' && token ? `registration:${token}` : 'login'

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&access_type=online&prompt=select_account&state=${encodeURIComponent(
      state
    )}`
    const width = 500
    const height = 600
    const left = (window.screen.width - width) / 2
    const top = (window.screen.height - height) / 2

    const messageListener = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) {
        return
      }

      if (event.data.type === 'GOOGLE_OAUTH_SUCCESS') {
        onSuccess({
          ...event.data.user,
          operation: event.data.operation,
          message: event.data.message,
          isExistingUser: event.data.isExistingUser || false,
          registrationComplete:
            event.data.operation === 'registration' ||
            event.data.operation === 'existing_user_login',
        })
        window.removeEventListener('message', messageListener)
      } else if (event.data.type === 'GOOGLE_OAUTH_ERROR') {
        const errorDetails = {
          message: event.data.error || 'Error en la autenticación',
          code: event.data.errorCode || 'UNKNOWN_ERROR',
          originalError: event.data.originalError,
        }

        if (onError) {
          onError(errorDetails)
        }
        window.removeEventListener('message', messageListener)
      }
    }

    window.addEventListener('message', messageListener)

    const popup = window.open(
      authUrl,
      'GoogleOAuth',
      `width=${width},height=${height},top=${top},left=${left}`
    )

    if (!popup) {
      if (onError) {
        onError({
          message: 'No se pudo abrir la ventana de autenticación',
          code: 'POPUP_BLOCKED',
        })
      }
      window.removeEventListener('message', messageListener)
      return
    }

    const checkClosed = setInterval(() => {
      if (popup?.closed) {
        window.removeEventListener('message', messageListener)
        clearInterval(checkClosed)
      }
    }, 500)
  }

  return (
    <button className={styles.googleButton} onClick={handleClick} type="button">
      <div className={styles.iconContainer}>
        <img src={GoogleIcon} alt="Google" className={styles.googleIcon} />
      </div>
      <span className={styles.buttonText}>{label}</span>
    </button>
  )
}
